const uiCompat = {
  toasted: null,
  bvModal: null
}

export function registerUiCompat(controllers = {}) {
  uiCompat.toasted = controllers.toasted || null
  uiCompat.bvModal = controllers.bvModal || null
}

export function getUiCompat() {
  return uiCompat
}
